import { Component, OnInit } from '@angular/core';
import { RestService } from 'src/app/services/rest.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EcommerceUserInfo } from 'src/app/models/models';
import { User } from 'src/app/models/RestModels';
import { BaseComponent } from '../base/base.component';
import { Location } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { Observable, forkJoin } from 'rxjs';
import { GetEmpty } from 'src/app/classes/Empties';
import { Ecommerce_User, Role } from 'src/app/models/RestModels';

@Component({
  selector: 'app-save-ecommerce-user',
  templateUrl: './save-ecommerce-user.component.html',
  styleUrls: ['./save-ecommerce-user.component.css']
})
export class SaveEcommerceUserComponent extends BaseComponent implements OnInit {

  user: User = GetEmpty.user();
  is_loading: boolean = false;
  editing: boolean = false;
  ecommerce = GetEmpty.ecommerce();
  
  show_add_user: boolean = false;
  new_user: User = GetEmpty.user();
  roles: Role[] = [];
  new_ecommerce_user_info: Partial<EcommerceUserInfo> = {};

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const id = params['id'];
      if (id) {
        this.editing = true;
        this.is_loading = true;
        this.sink = this.rest.user.get(id).subscribe(user => {
          this.is_loading = false;
          this.user = user;
        });
      }
    });

	this.rest.role.search({limit: 1000}).subscribe(response=>{
		this.roles = response.data;
	});
  }

  save() {
    this.is_loading = true;
    let obs: Observable<User>;
    if (this.editing) {
      obs = this.rest.user.update(this.user);
    } else {
      obs = this.rest.user.create(this.user);
    }

    this.sink = obs.subscribe(
      (result) => {
        this.is_loading = false;
        this.router.navigate(['/users']);
      },
      (error) => {
        this.is_loading = false;
        alert(error.error);
      }
    );
  }

  addUser(event: Event)
	{
		event.preventDefault();
		this.is_loading = true;
	
		let ecommerce_user:Ecommerce_User = {
			id:0,
			user_id: 0,
			ecommerce_id: this.ecommerce.id,
			created: new Date(),
			updated: new Date(),
			created_by_user_id: this.rest.current_user.id,
			updated_by_user_id: this.rest.current_user.id,
			type: this.new_ecommerce_user_info.type
		};

		let ecommerce_user_info:EcommerceUserInfo = {
			ecommerce_user,
			user: this.new_user,
			type: this.new_ecommerce_user_info.type
		};

		this.is_loading = true;

		this.sink = this.rest.ecommerce_user_info.create(ecommerce_user_info )
		.subscribe
		({
			error:(error)=>this.showError(error),
			next:(_ecommerce_user_info)=>
			{
				this.is_loading = false;
				this.showSuccess('El usuario se ha registrado exitosamente');
				this.show_add_user = false;
				this.new_user = GetEmpty.user();
				this.is_loading = false;
			}
		});
	}
}
